import Charts from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { H4, H6 } from "../../../AbstractElements";
import { CompareLastMonth, TotalProductHeading } from "../../../Constant";
import { LINE_CHART_3 } from "../../../Data/Widgets/ChartWidgets";

const TotalProduct = () => {
  return (
    <Col xl="4" md="12" className="box-col-4">
      <Card className="o-hidden">
        <div className="chart-widget-top">
          <CardBody className="row pb-0 m-0">
            <Col xl="9" lg="8" xs="9" className="p-0">
              <H6 className="mb-2">{TotalProductHeading}</H6>
              <H4>93M</H4>
              <span>{CompareLastMonth}</span>
            </Col>
            <Col xl="3" lg="4" xs="3" className="text-end p-0">
              <H6 className="txt-success">+65%</H6>
            </Col>
          </CardBody>
          <div id="chart-widget3">
            <Charts className="flot-chart-placeholder" options={LINE_CHART_3} series={LINE_CHART_3.series} height="170" type="area"/>
          </div>
        </div>
      </Card>
    </Col>
  );
};

export default TotalProduct;
